// extracted by mini-css-extract-plugin
module.exports = {"cardBox":"ShopMatchCard_cardBox__i9G5q","content":"ShopMatchCard_content__zh2GB","reservation":"ShopMatchCard_reservation__5xDjJ"};